module.exports = __webpack_public_path__ + "static/media/arrow-off-sudoeste.50e871d3.png";